import React from 'react'
import {withRouter} from "react-router-dom"
import '../../../assets/style/getStarted.scss'
import {withStyles} from "@material-ui/core/styles";
import {RedocStandalone} from "redoc";
import BILLoader from "../BILLoader/BILLoader";

const styles = theme => ({
    tab: {
        color: '#702F8A',
        '&:hover': {
            color: 'black'
        },
        '&:focus': {
            boxShadow: 'none',
            outline: 'none'
        },
        fontWeight: 300,
        minWidth: '90px',
        width: '90px'
    },
    indicator: {
        backgroundColor: '#702F8A'
    },
    link: {
        display: 'flex',
        color: '#008577',
        '&:hover': {
            color: 'grey'
        },
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    }
});

const AsciiDoc = (props) => {

    const {staticResource} = props
    return (
        <>
            <div className="intl-spinner-container">
                <BILLoader/>
            </div>
            <RedocStandalone
                specUrl={`${window.portalBaseUrl}${staticResource}`}
                options={{
                    schemaExpansionLevel: 'all',
                    hideLoading: true,
                    disableSearch: true,
                    hideSecuritySection: true,
                    theme: { colors: { primary: { main: '#702fa8' } } }
                }}
                onLoaded={error => {
                    Promise.resolve()
                        //Remove loader
                        .then(async() => document.getElementById("bil-loader").remove())
                        //Delete powered info
                        .then(async() => await document.querySelectorAll('a').forEach((a) => {
                            if (a.href === "https://redocly.com/redoc/") {
                                a.parentElement.removeChild(a);
                            }}));
                }}
            />
        </>
    );
}

export default (withStyles(styles)(withRouter(AsciiDoc)))
